import React from 'react';

import type { RichText } from '@schibsted/frapi-schema';

import { RichTextBlock } from '../../helpers/rich-text.js';
import { safeParseJson } from '../../../helpers/safe-parse-json.js';

const ListDescription: React.FC<{ text: string; className?: string }> = ({
  text,
  className,
}) => {
  const parsed = safeParseJson<string | RichText>(text, text);

  if (typeof parsed === 'string') {
    return <p className={className}>{parsed}</p>;
  }

  return (
    <div className={className}>
      {parsed.map((c, i) => (
        <RichTextBlock key={i} content={c} />
      ))}
    </div>
  );
};

export { ListDescription };
